import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredHomeFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.60094 1.13405C7.83566 0.955317 8.16434 0.955317 8.39906 1.13405L14.2491 5.58859C14.4074 5.70916 14.5 5.89453 14.5 6.09091V13.0909C14.5 13.5972 14.2946 14.0828 13.9289 14.4408C13.5632 14.7989 13.0672 15 12.55 15H3.45C2.93283 15 2.43684 14.7989 2.07114 14.4408C1.70545 14.0828 1.5 13.5972 1.5 13.0909V6.09091C1.5 5.89453 1.59261 5.70916 1.75094 5.58859L7.60094 1.13405ZM6.7 13.7273H9.3V8.63636H6.7V13.7273Z"
      fill="black"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColouredHomeFilled)
const IconSvgColouredHomeFilled = createIcon(
  ForwardRef,
  'SvgColouredHomeFilled',
)
export default IconSvgColouredHomeFilled
